import React from 'react'

export const BoxLoader = () => {
    return (
        <div className='ph-box-loader'></div>
    )
}
